import { SET_IS_SELF_REGISTER_LANDING_PAGE, SET_SELF_REGISTARTION_TYPE, SET_USER_TYPE_DATA,SET_IS_SELF_REGISTER, registerationActionType, SET_IS_GENDER_TYPE_PAGE } from "@store/types/registerationTypes";

export interface RegisterationState {
    isGenderTypePage: boolean,
    isSelfRegisterLandingPage: boolean,
    isSelfRegister: boolean,
    selfRegistrationType: string,
    userType:any
};

export const initialState: RegisterationState =
{
    isGenderTypePage: false,
    isSelfRegisterLandingPage: false,
    isSelfRegister: false,
    selfRegistrationType: '',
    userType: {
        name: '',
        id: '',
        code: '',
    }
}


const registerationReducer = (
    state = initialState,
    action: registerationActionType,
): RegisterationState => {
    switch (action.type) {
        case SET_IS_SELF_REGISTER:
            return { ...state, isSelfRegister: action.payload };
        case SET_SELF_REGISTARTION_TYPE:
            return { ...state, selfRegistrationType: action.payload };
        case SET_IS_GENDER_TYPE_PAGE:
            return { ...state, isGenderTypePage: action.payload };
        case SET_IS_SELF_REGISTER_LANDING_PAGE:
            return { ...state, isSelfRegisterLandingPage: action.payload };
        case SET_USER_TYPE_DATA:
            return { ...state, userType: action.payload };
        default:
            return state;
    }
};

export default registerationReducer;